import { getContrastRatio } from "@mui/system"

export const getContrastTextColor = (color?: string): string | undefined => {
  if (!color) return undefined
  return getContrastRatio(color, '#fff') > 1.5 ? '#fff' : '#000000de'
}

export default getContrastTextColor